import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter, Switch, Route, matchPath } from "react-router-dom";
import routes from "./src/routes/routes.js";
import * as reducers from "./src/reducers";
import { Provider } from "react-redux";
import { createStore, compose, applyMiddleware, combineReducers } from "redux";
import RouterChanges from "./src/components/RouterChangesV2.js";
import logger from "redux-logger";
import smoothscroll from "smoothscroll-polyfill";
import thunkMiddleware from "redux-thunk";
import * as actions from "./src/actions/Actions.js";
import Navigation from "./src/pages/NavigationV2.js";
import Footer from "./src/components/Footer.js";
import { persistStore, persistReducer, createMigrate } from "redux-persist";
import ErrorBoundary from "./src/components/ErrorBoundary.js";
import storage from "redux-persist/lib/storage"; // defaults to localStorage for web
import "core-js/features/object";
import Helper from "./src/functions/Helper.js";
import "./src/css/custom_bootstrap.scss";
//import "./src/css/month-picker.css";
import "swiper/swiper.scss";
import "lazysizes";
import "./src/css/lazy.scss";
import "./src/css/pagination.scss";
import "./src/css/navigation.scss";
import "./src/css/additional_swiper.css";

//import "./src/css/swiper.css"
import "./src/css/shoe_filter_react.css";
import "isomorphic-fetch";
import "./src/css/StyleModal.css";
import AdInjector from "./src/components/AdInjector.js";

import SwiperCore, {
  Lazy,
  Pagination,
  Navigation as SwiperNavigation,
} from "swiper";

SwiperCore.use([Lazy, Pagination, SwiperNavigation]);

const migrations = {
  0: (state) => {
    return {
      ...state,
    };
  },
  1: (state) => {
    return {
      ...state,
      persistData: { ...state.persistData, likes: [] },
    };
  },
  2: (state) => {
    return {
      ...state,
      persistData: { ...state.persistData, sortStylesBy: 0 },
    };
  },
};

const persistConfig = {
  key: "shoeReviews",
  storage,
  whitelist: ["persistData"],
  version: 1,
  migrate: createMigrate(migrations, { debug: true }),
};

smoothscroll.polyfill();
const supportsHistory = "pushState" in window.history;
let middleware =
  process.env.NODE_ENV === "development"
    ? [
        logger,
        thunkMiddleware,
        require("redux-immutable-state-invariant").default(),
      ]
    : [thunkMiddleware];

const reducer = combineReducers(reducers);
const persistedReducer = persistReducer(persistConfig, reducer);
const store = createStore(
  persistedReducer,
  undefined,
  compose(applyMiddleware(...middleware))
);
const persistor = persistStore(store, null, () => {
  store.dispatch({ type: "REHYDRATION_FINISHED" });
});
const currentRoute =
  routes.find((route) => matchPath(window.location.pathname, route)) || {};

store.dispatch(
  actions.initial_data({
    ...window.__INITIAL_DATA__.data,
    overview: window.__INITIAL_DATA__.overview,
  })
);
store.dispatch(actions.menu(window.__INITIAL_DATA__.menu));

if (window.__INITIAL_DATA__.filters) {
  let filters = window.__INITIAL_DATA__.filters;
  store.dispatch({ type: "SETFILTERS", value: filters });
  store.dispatch({ type: "APPLYFILTER" });

  ///SEO SPLIT TEST
  if (filters.filterType === "player") {
    let player = filters.filters[0].list[0].option;
    if (["Paul George", "Kevin Durant"].includes(player)) {
      store.dispatch({ type: "SORT", value: { sortBy: "rating" } });
    }
  }
}
store.dispatch(actions.filterObject(window.__INITIAL_DATA__.filterObject));
store.dispatch(actions.urlMapping(window.__INITIAL_DATA__.url_mapping));

if (Helper.getValueFromQueryString(window.location.search, "favs")) {
  store.dispatch(actions.switchValue(1));
}

if (Helper.getValueFromQueryString(window.location.search, "shoe_name")) {
  store.dispatch(
    actions.searchtext(
      Helper.getValueFromQueryString(window.location.search, "shoe_name")
    )
  );
}

if (window.__ROUTE_DATA__ && currentRoute?.fetchToDo === "shoe") {
  let fetchedDataResponse = window.__ROUTE_DATA__;
  store.dispatch(actions.shoeData(fetchedDataResponse));

  delete window.__ROUTE_DATA__;
}

//cleaning server side rendering of footer since createPortal doesnt allow for hydrating
document.getElementById("react_footer").innerHTML = "";

ReactDOM.hydrate(
  <ErrorBoundary>
    <Provider store={store}>
      <BrowserRouter forceRefresh={!supportsHistory}>
        <RouterChanges urlMapping={store.getState().data.urlMapping} />
        <div>
          <AdInjector siteId="622f42f8688af31b50b63a81" />
          <Navigation />
          <div>
            <Switch>
              {routes.map(
                ({ path, exact, component: Component, useThisKey }) => (
                  <Route
                    key={path}
                    path={path}
                    exact={exact}
                    render={(props) => {
                      if (store.getState().data.loaded === true) {
                        let finalKey = useThisKey
                          ? useThisKey
                          : props.match.url;
                        return <Component key={finalKey} {...props} />;
                      } else {
                        return <div></div>;
                      }
                    }}
                  />
                )
              )}
              <Route render={(props) => "404"} />
            </Switch>
          </div>
          {ReactDOM.createPortal(
            <Footer popularStyles={window.__INITIAL_DATA__.footer} />,
            document.getElementById("react_footer")
          )}
        </div>
      </BrowserRouter>
    </Provider>
  </ErrorBoundary>,
  document.getElementById("shoe_filter_container")
);

/*
ReactDOM.hydrate(
  <ErrorBoundary>
    <Provider store={store}>
      <BrowserRouter forceRefresh={!supportsHistory}>
        <RouterChanges>
          <Footer popularStyles={window.__INITIAL_DATA__.footer} />
        </RouterChanges>
      </BrowserRouter>
    </Provider>
  </ErrorBoundary>
  ,
  document.getElementById('react_footer')
);*/
